export const byX = (block) => {
    return block.reduce(
    (a,b) => {
        if (!a[b.x]) { a[b.x] = []; }
        a[b.x].push(b);
        return a;
    }, {});
}

export const byY = (block) => {
    return block.reduce(
    (a,b) => {
        if (!a[b.y]) { a[b.y] = []; }
        a[b.y].push(b);
        return a;
    }, {});
}


